import { useTranslation } from "react-i18next";
import StepHeading from "./StepHeading";

// Step 7 — pick one or more starting exercise-library presets. Each preset is a
// tag-defined group of catalog exercises; the selected ids are resolved into a
// real exerciseLibrary (deduped across presets) on the server at register-coach.
const StepExerciseLibrary = ({
  current,
  presets = [],
  selectedPresets = [],
  onTogglePreset,
  onSkip,
}) => {
  const { t } = useTranslation("auth");

  return (
    <div className="step-body step-exercise-library">
      <StepHeading
        current={current}
        title={t("onboardingWizard.exerciseLibrary.title")}
        subtitle={t("onboardingWizard.exerciseLibrary.subtitle")}
      />

      <div className="preset-cards">
        {presets.map(({ id, label, count }) => {
          const selected = selectedPresets.includes(id);
          return (
            <button
              key={id}
              type="button"
              className={`preset-card ${selected ? "selected" : ""}`}
              aria-pressed={selected}
              onClick={() => onTogglePreset(id)}
            >
              <span className="preset-title">
                {t(`onboardingWizard.exerciseLibrary.presets.${id}`, {
                  defaultValue: label,
                })}
              </span>
              <span className="preset-count">
                {t("onboardingWizard.exerciseLibrary.cardCount", { count })}
              </span>
            </button>
          );
        })}
      </div>

      <button type="button" className="preset-manual-later" onClick={onSkip}>
        {t("onboardingWizard.exerciseLibrary.setupManuallyLater")}
      </button>

      <input
        type="hidden"
        name="selectedPresets"
        value={JSON.stringify(selectedPresets)}
      />
    </div>
  );
};

export default StepExerciseLibrary;
